import { DIALOG_DATA, DialogRef } from "@angular/cdk/dialog";
import { CommonModule, DOCUMENT } from "@angular/common";
import { AfterViewInit, Component, HostListener, Inject, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, Validators } from "@angular/forms";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { FeedbackService } from "src/app/rest/feedback.service";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { DialogContainerComponent } from "../../dialog-container/dialog-container.component";
import { StarRatingComponent } from "../../star-rating/star-rating/star-rating.component";

@Component({
    selector: "app-greenhouse-application",
    templateUrl: "./greenhouse-application.component.html",
    standalone: true,
    imports: [CommonModule, RouterModule, FormsModule, StarRatingComponent, DialogContainerComponent],
})
export class GreenhouseApplicationComponent implements OnInit, AfterViewInit {
    @ViewChildren(StarRatingComponent) starRating: QueryList<StarRatingComponent>;
    @ViewChild("iframe") iframe;
    public iframeSrc: SafeUrl;
    public submitted = false;
    public finalised = false;
    public ratingForm: FormGroup;

    constructor(
        @Inject(DIALOG_DATA) public data: { jobId: string; voyseJobId: string; jobTitle: string },
        private dialogRef: DialogRef<GreenhouseApplicationComponent>,
        @Inject(DOCUMENT) private document,
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private subdomain: SubdomainService,
        private fb: FormBuilder,
        private feedback: FeedbackService,
        private gtag: GtagService,
    ) {
        const ratingFormConfig = {
			rating: [3, Validators.required],
			ghJobId: [],
			job: [],
			employer: [this.subdomain.getClientId()],
		};
		this.ratingForm = this.fb.group(ratingFormConfig);
    }

    ngOnInit(): void {
        let src = "https://boards.greenhouse.io/embed/job_app?token=";
        src += this.data.jobId;
        src += "&b=" + this.document?.defaultView?.location?.href;
        if (this.route?.snapshot?.queryParams?.gh_src) {
            src += "&t=" + this.route.snapshot.queryParams.gh_src;
        }
        if (this.route?.snapshot?.queryParams?.gh_jid) {
            src += "&token=" + this.route.snapshot.queryParams.gh_jid;
        }
        src += "#app";
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(src);
    }

    ngAfterViewInit() {
		this.starRating.changes.subscribe((result: QueryList<StarRatingComponent>) => {
			if (result?.first) {
				result.first.ratingUpdated.subscribe(this.handleRatingChange.bind(this));
			}
		});
	}

    @HostListener("window:message", ["$event"])
    onMessage(e: MessageEvent) {
        if (e.origin?.includes("greenhouse") && e.data === "greenhouse.confirmation") {
            this.iframe.nativeElement.style.display = "none";
            this.submitted = true;
            this.ratingForm.get('ghJobId').setValue(this.data.jobId);
			this.ratingForm.get('job').setValue(this.data.voyseJobId);
            this.gtag.fireThirdPartyApplyEvent(this.data.voyseJobId, this.data.jobTitle);
        }
    }

    public close() {
        this.dialogRef.close();
    }

    private handleRatingChange(value: number) {
		this.ratingForm.get('rating').setValue(value);
		this.submitFeedback();
	}

	private submitFeedback() {
		this.feedback.post(this.ratingForm.getRawValue()).subscribe(() => {
			this.finalised = true;
		});
	}
}
